﻿import { customElement } from 'lit/decorators.js';
import { AtlGridProps, AtlGridTagNames } from './grid.props';
import { getGlobalStyleSheets } from '../../global-styles';
import {
   AlignItems,
   AlignItemsValuesMap,
   Breakpoint,
   BreakpointValuesMap,
   enumAttributeConverter,
} from '../enum-types';
import { JustifyContent, JustifyContentValues } from '../justify-content';
import { ClassComponent } from '../ClassElement';

@customElement(AtlGridTagNames.Grid)
export class AtlGrid extends ClassComponent implements AtlGridProps {
   declare stackVertically: boolean;
   declare inline: boolean;
   declare alignItems?: AlignItems;
   declare justifyContent?: JustifyContent;
   declare breakpoint?: Breakpoint;

   static properties = {
      stackVertically: { type: Boolean, attribute: 'stack-vertically' },
      inline: { type: Boolean },
      alignItems: {
         type: String,
         attribute: 'align-items',
         converter: enumAttributeConverter(AlignItems),
      },
      justifyContent: {
         type: String,
         attribute: 'justify-content',
         converter: enumAttributeConverter(JustifyContent),
      },
      breakpoint: {
         type: String,
         converter: enumAttributeConverter(Breakpoint, Breakpoint.Large),
      },
   };

   static styles = [...getGlobalStyleSheets()];

   get _classesStartingWith(): string[] {
      return ['row-cols-', 'align-items-', 'justify-content-'];
   }
   get _classesContaining(): string[] {
      return ['row', 'grid', 'flex-column'];
   }
   _buildClassList(classList: string[]): void {
      classList.push('row');
      classList.push('grid');
      if (this.stackVertically) {
         classList.push('flex-column');
      }
      if (this.inline) {
         classList.push(
            `row-cols-${BreakpointValuesMap[this.breakpoint || Breakpoint.Large]}-auto`
         );
      }
      if (this.alignItems) {
         classList.push(AlignItemsValuesMap[this.alignItems]);
      }
      if (this.justifyContent) {
         classList.push(JustifyContentValues[this.justifyContent]);
      }
   }
}
